import { render, staticRenderFns } from "./StaffCamera.vue?vue&type=template&id=3bf902c5&"
import script from "./StaffCamera.vue?vue&type=script&lang=js&"
export * from "./StaffCamera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports